var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m25.129 14.325-9.609-8.86 1.538-1.68 12.995 11.95v.932l-12.98 11.965-1.553-1.609 9.623-8.917a3.05 3.05 0 0 1 1.058-.663H1.933v-2.47H26.2a3.3 3.3 0 0 1-1.072-.648"
  })));
};
export default SvgArrow;